import React, { useEffect, useState } from 'react'
import Button1 from '../../../Button/Button1'

import classes from "./StatePicker.module.css"
import Button2 from '../../../Button/Button2'
const StatePicker = ({ pinText, outputPin, HandleOutputState, index, states }) => {

  const [activeButton, setActiveButton] = useState("ignore")

  useEffect(() => {
    setActiveButton(states)
  }, [states])
  

  const Handler = (buttonText) => {
    HandleOutputState(outputPin, buttonText);
    setActiveButton(buttonText);
  }

  return (
    <div className={classes.container} key={index} >

      <h3>{pinText}</h3>
      <div className={classes.buttonContainer}>
        <Button2 style={{backgroundColor: activeButton === "arm" ? "var(--Primary-Color)" : "#cdcdcd"}}  onClick={() => Handler("arm")}>arm</Button2>
        <Button2 style={{backgroundColor: activeButton === "disarm" ? "var(--Primary-Color)" : "#cdcdcd"}}  onClick={() => Handler("disarm")} >disarm</Button2>
        <Button2 style={{backgroundColor: activeButton === "ignore" ? "var(--Primary-Color)" : "#cdcdcd"}}  onClick={() => Handler("ignore")}>ignore</Button2>
      </div>
    </div>
  )
}

export default StatePicker